import { workdayColor, blackFont, defaultBorderColor } from './colorConfig';
import { Employee } from '~/common/entities/Department/DepartmentTypes';
import { Th } from '@chakra-ui/react';

type Props = { employee: Employee };

export const EmployeeHeader = ({ employee }: Props) => {
  return (
    <Th
      backgroundColor={workdayColor}
      color={blackFont}
      wordBreak="unset"
      whiteSpace="nowrap"
      borderBottomWidth={1}
      borderColor={defaultBorderColor}
    >{`${employee.user.last_name}, ${employee.user.first_name}`}</Th>
  );
};
